import { defineStore } from 'pinia';
import { notify } from 'notiwind';

export const useDashboardStore = defineStore('dashboard', {
    state: () => ({
        loading: false,
        users: [],
        user: null,
        annualFees: 0,
        card: {},
        points: 0,
        change: '--',
        direction: '',
        open: 0,
        closed: 0,
        count: 0,
        nextCardDate: '--',
        nextCardTitle: '',
    }),
    actions: {
        getDashboardData() {
            this.getUsers();
            this.getDashboardCards();
        },
        getDashboardCards() {
            this.getTopCard();
            this.getAnnualFees();
            this.getNumberOfPoints();
            this.getNumberOfCards();
            this.getFiveTwentyFourCount();
        },
        getUsers() {
            axios
                .get('/api/wallets/users')
                .then((response) => {
                    this.users = response.data.users;
                    this.user = this.users[0];
                    this.users[0].active = true;
                })
                .catch((response) => {});
        },
        getAnnualFees() {
            ApiService.apiCall(
                '/dashboard/cards/annual-fees',
                'post',
                this.user
            )
                .then((response) => {
                    this.annualFees = response.data.annual_fees;
                })
                .catch((response) => {
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'There was a problem trying to get annnual fees card.',
                        },
                        4000
                    );
                });
        },
        getTopCard() {
            this.loading = true;
            ApiService.apiCall('/dashboard/cards/top-card', 'post', this.user)
                .then((response) => {
                    this.card = response.data;
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                })
                .catch((response) => {
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'There was a problem trying to get top card.',
                        },
                        4000
                    );
                });
        },
        getNumberOfPoints() {
            this.loading = true;
            ApiService.apiCall(
                '/dashboard/cards/number-of-points',
                'post',
                this.user
            )
                .then((response) => {
                    this.points = response.data.points;
                    this.change = response.data.prevChange;
                    this.direction = response.data.direction;
                    this.loading = false;
                })
                .catch((response) => {
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'There was a problem trying to get number of points.',
                        },
                        4000
                    );
                    this.loading = false;
                });
        },
        getNumberOfCards() {
            ApiService.apiCall(
                '/dashboard/cards/number-of-cards',
                'post',
                this.user
            )
                .then((response) => {
                    this.open = response.data.open;
                    this.closed = response.data.closed;
                })
                .catch((response) => {
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'There was a problem trying to get number of cards.',
                        },
                        4000
                    );
                });
        },
        getFiveTwentyFourCount() {
            ApiService.apiCall(
                '/dashboard/cards/five-twenty-four',
                'post',
                this.user
            )
                .then((response) => {
                    this.count = response.data.count;
                    this.nextCardDate = response.data.next_card_date;
                    this.nextCardTitle = response.data.next_card_title;
                })
                .catch((response) => {
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'There was a problem trying to get 5/24 count.',
                        },
                        4000
                    );
                });
        },
        updateUserPreference(preference) {
            this.loading = true;
            const user = this.users.find(u => u.active);
            ApiService.apiCall(
                `/user-settings/${preference}`,
                'put',
                { uuid: user.uuid }
            ).then(() => {
                user.start_guide_completed = true;
            })
            .catch(error => {
                console.error('Error updating the configuration:', error);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        setUser(user) {
            this.users.forEach((u) => {
                u.active = false;
            });
            this.users[this.users.indexOf(user)].active = true;
            this.user = user;
            this.getDashboardCards();
        },
    },
});
